/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function openCity(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}


$(document).ready(function(){
var buttonSlt = '[data-minus-qtt], [data-plus-qtt]',
      buttonElm = $(buttonSlt);
  
  var prod_subt = $(".product-form .product-form__info-item .price-list .price.price--highlight").text();
  if(prod_subt == '') {
  	prod_subt = $(".product-form .product-form__info-item .price-list .price").text();
  }
  prod_subt = prod_subt.replace('$', '');
  $('.subtotallbox .subt-price').text(prod_subt);

  $(document).on('click', buttonSlt, function(e) {
    
      e.preventDefault();
      e.stopPropagation();
    
      var self = $(this),
          input = $('.quantity input[name="quantity"]'),
          oldVal = parseInt(input.val()),
          newVal = 1;

      switch (true) {
          case (self.hasClass('plus')): {
              newVal = oldVal + 1;
              break;
          }
          case (self.hasClass('minus') && oldVal > 1): {
              newVal = oldVal - 1;
              break;
          }
      }

      input.val(newVal).trigger('change');
    
      var prod_subt = $(".product-form .product-form__info-item .price-list .price.price--highlight").text();
      if(prod_subt == '') {
        prod_subt = $(".product-form .product-form__info-item .price-list .price").text();
      }
      prod_subt = prod_subt.replace('$', '');
      $('.subtotallbox .subt-price').text(prod_subt*newVal);


  });
});
